export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12796.f4ac7a7b.jpg";